import { Component, OnInit } from '@angular/core';
import { DynamicDialogRef, DynamicDialogConfig } from 'primeng/dynamicdialog';

@Component({
  selector: 'app-close-invoice-confirmation',
  templateUrl: './close-invoice-confirmation.component.html',
  styleUrls: ['./close-invoice-confirmation.component.scss'],
})
export class CloseInvoiceConfirmationComponent implements OnInit {
  reason: string = '';

  constructor(
    public ref: DynamicDialogRef,
    public config: DynamicDialogConfig
  ) {}

  ngOnInit(): void {}

  onCancel(): void {
    this.ref.close(null);
  }

  onConfirm(): void {
    const trimmedReason = this.reason?.trim() || undefined;
    this.ref.close(trimmedReason);
  }
}
